module.exports = __webpack_public_path__ + "img/swipe2-icon.4210e7c9.png";